import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaginate, ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

@Injectable()

export class ContratoProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) { }

  private FiltrarContratosPorPerfisUsuario(empresa: string, contratos: any[])
  {
    var usu = APIService.UsuarioLogado.Usuario;

    if(usu && usu.contratoLoginPerfils)
    {
      var perfis = usu.contratoLoginPerfils;

      var isTodsContratos = perfis.find(x => (x.idEmpresa == "TODS" || x.idEmpresa == "TODOS_TODS" || x.idEmpresa == empresa) && (x.numContrato == "TODS" || x.numContrato == "TODOS_TODS")) 
        ? true : false;

      if(isTodsContratos)
      {
        return contratos;
      }

      var contratosFiltrados = contratos.filter(x => perfis.find(y => y.numContrato == x.numContrato));

      return contratosFiltrados;
    }
    else
    {
      return contratos;
    }
  }

  
  /**
   * Lista contrato segmentos
   * @param empresa empresa do usuário
   * @param forcarTods se é para forçar a busca de todos contratos independente do que você tem permissão
   * @returns 
   */
  getContratoSegmentos(empresa:any, forcarTods = true): Promise<{Item: any, erro: string}> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'contrato?operacao=' + 'contratosegmentos' + '&empresa=' + empresa
      
      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (Array.isArray(jsonData) && jsonData.length!=0)
          {
            if (jsonData[0].status_ret!="NOK")
            {

              let contratos = [];

              jsonData.forEach(contratoSegmento => {
                contratoSegmento.contratos.forEach(contrato => {

                  let contratoExistente = contratos.find(x => x.numContrato == contrato.numContrato && x.idEmpresa == contrato.idEmpresa && x.dtRescisao == contrato.dtRescisao);

                  if(contratoExistente)
                  {
                    contratoExistente.idSegmentos.push({
                      idSegmento: contratoSegmento.idSegmento,
                      desSegmento: contratoSegmento.desSegmento
                    });

                    return;
                  }

                  contratos.push({
                    ...contrato,
                    idSegmentos: [
                      {
                        idSegmento: contratoSegmento.idSegmento,
                        desSegmento: contratoSegmento.desSegmento
                      }
                    ]
                  });
                });
              })

              if(forcarTods == false) {
                contratos = this.FiltrarContratosPorPerfisUsuario(empresa, contratos);
              }

                var datasuccess={
                  'Item':contratos,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta dos contratos.'
              }
              me.itemret=errodatavazio;
            }
            
            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  
  /**
   * Lista usuários
   * @param empresa empresa do usuário
   * @param filtro filtro de nome ou cpf do usuário
   * @param isJoin se é para fazer join com outras tabelas
   * @param forcarTods se é para forçar a busca de todos contratos independente do que você tem permissão
   * @returns 
   */
  get(empresa:any, filtro:any, isJoin: boolean = true, forcarTods = true): Promise<{Item: any, erro: string}> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'contrato?searchString=' + filtro + '&empresa=' + empresa + '&isJoins=' + isJoin;
      
      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData[0].status_ret!="NOK")
            {

              if(forcarTods == false) {
                jsonData = this.FiltrarContratosPorPerfisUsuario(empresa, jsonData);
              }

                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta dos contratos.'
              }
              me.itemret=errodatavazio;
            }
            
            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  getPaginated(paginacao: ApiPaginate) : Promise<ApiPaginateResult> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'contrato?operacao=page&' + paginacao.geraAPIUrl();

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns 
   */
  addupdate(dadosJson:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      var requestData=JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'contrato';
      //console.log(requestData);
      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }


  delete(id:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'contrato?id=' + id;
      
      me.http.delete(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  
  

}
